import './PROD.scss';
import {PageManager} from '@mvps-genesis/bootstrap';
import 'extensions/quantify';
import AjaxAddToCart from 'extensions/ajax-add-to-cart';
import shareProduct from 'extensions/share-product';
import waitForExpression from '@mvps-genesis/wait-for-expression';
import tippy from 'tippy.js';

export default class PROD extends PageManager {

	constructor (pageContext) {

		super(pageContext);

	}

	// eslint-disable-next-line require-await
	onReady () {

		/**
		 * Initialize ajax add to cart functionality
		 */
		 const purchaseForm = document.getElementById('js-purchase-form');

		 if (purchaseForm && purchaseForm.querySelector('.js-add-to-cart')) {
			 new AjaxAddToCart(purchaseForm);
		 }

		/**
		 * This removes the default Miva `closeup_backing` container.
		 */
		var closeupBacking = document.querySelector('div.closeup_backing');

		window.addEventListener('load', function () {
			if (closeupBacking) {
				closeupBacking.parentNode.removeChild(document.querySelector('div.closeup_backing'));
			}
		});

		/**
		 * Initialize share product
		 */
		shareProduct();

		/**
		 * TrustSpot Scroll to Events
		 */
		this.trustSpotScroll();

		/**
		 * Update URL with variant_id (on variant change)
		 */
		this.variantChange();

		/**
		 * Load tooltips
		 */
		// eslint-disable-next-line no-undef
		if (mivaJS.Attribute_Codes) {
			this.toolTips();
		}

		this.recentlyViewed();
	}

	trustSpotScroll () {
		let trustspotInlineElements = '';

		waitForExpression(
			() => {

				trustspotInlineElements = document.querySelectorAll('.ts-reviews-rating-options a');

				if (!trustspotInlineElements.length) {
					return false;
				}

				return trustspotInlineElements;

			},
			() => {

				const trustspotReviewWidget = document.getElementById('trustspot-widget-wrapper');

				if (trustspotInlineElements.length) {
					for (const inlineElement of trustspotInlineElements) {
						inlineElement.addEventListener('click', function (event) {
							event.preventDefault();
							trustspotReviewWidget.scrollIntoView();
						});
					}
				}

			}
		);
	}

	variantChange () {
		function variantUrlUpdate (variant) {
			// Get query string parameters
			const parameters = new URLSearchParams(window.location.search);
			const baseUrl = window.location.protocol + '//' + window.location.host + window.location.pathname;

			// Update/set query string parameter
			parameters.set('variant_id', variant.variant_id);

			// Stringify
			let parametersString = parameters.toString();
			let newUrl = baseUrl + '?' + parametersString;

			// History API
			history.replaceState('', '', newUrl);
		}

		waitForExpression(
			() => { return typeof MivaEvents !== 'undefined'; },
			() => {

				// eslint-disable-next-line no-undef
				MivaEvents.SubscribeToEvent('variant_changed', variantUrlUpdate);

			}
		);
	}

	// eslint-disable-next-line max-lines-per-function
	toolTips () {

		// eslint-disable-next-line no-undef
		const link = `https://${mivaJS.Store_Domain}/tooltips.html?Feed_AccessKey=tt_check&attr_codes=${mivaJS.Attribute_Codes}`;

		(function () {

			fetch(link, {
				method: 'GET'
			})
				.then(results => results.json())
				.then(data => {

					if (data.tooltips_attributes) {
						const attrs = data.tooltips_attributes;

						// Add class to associate UI
						document.getElementById('js-purchase-form').classList.add('x-tooltips--active');

						// Loop through and add HTML dynamically
						attrs.forEach(function (el) {

							if (el.tooltip) {
								let target = document.querySelectorAll(`[data-attribute="${el.code}"]`);

								if (target && target.length > 0) {
									let attr = target[0];
									let tip = `<span class="c-form-attribute-item"><span class="x-tooltip" data-tippy-content="${el.tooltip}">?</span></span>`;

									if (attr.type === 'radio' || attr.dataset.hook === 'attribute-swatch-select') {
										attr.parentElement.previousElementSibling.insertAdjacentHTML('beforeend', tip);
									} else if (attr.type === 'select-one' || attr.type === 'checkbox') {
										attr.parentElement.insertAdjacentHTML('afterend', tip);
									} else {
										attr.parentElement.insertAdjacentHTML('beforeend', tip);
									}

									attr.closest('.x-product-layout-purchase__options-attribute').classList.add('x-tooltip-container');
								}
							}

							// Init tippies
							tippy('.x-tooltip');

						});
					}

				})
				.catch(err => {
					console.error(err);
				});

		}());
	}

	recentlyViewed () {
		const recentlyViewedElement = document.getElementById('js-recently-viewed');
	
		if (!recentlyViewedElement) {
			return;
		}
	
		if (recentlyViewedElement.classList.contains('lazyloaded')) {
			this.loadRecentlyViewed();
			return;
		}
	
		document.addEventListener('lazybeforeunveil', (e) => {
			if (e.target.id === 'js-recently-viewed') {
				this.loadRecentlyViewed();
			}
		});
	}
	
	async loadRecentlyViewed () {
		const {default: RecentlyViewed} = await import('custom-extensions/recently-viewed');
	
		new RecentlyViewed(this.pageContext.Product_Code, this.pageContext.Japi_Url);
	}
}
